var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":("https://res.cloudinary.com/" + _vm.cloudName + "/video/upload/" + _vm.publicId + ".mp3"),"type":"audio/mpeg"}}),_vm._v(" הדפדפן שלך אינו תומך ברכיב האודיו ")])}
var staticRenderFns = []

export { render, staticRenderFns }